import { render, staticRenderFns } from "./receiving.vue?vue&type=template&id=25e66be7&"
import script from "./receiving.vue?vue&type=script&lang=js&"
export * from "./receiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports